<app-safe-select
  [options]="safeOptions()"
  [value]="selected()"
  (valueChange)="onChange($event)"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [allowClear]="optional()"
  [selectedClass]="!!selected() && selected() !== placeholder()"
></app-safe-select>
